import axios from './axios';
import SETTINGS from '../settings'
export default {
    getAgenda(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/agenda`, { params }).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    }
}